import React, { useEffect, useRef } from "react";
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import {
  ProposalSection,
  HeroSection,
  EvolutionarySection,
  DifferentialSection,
  ValueSection,
  PurposeProfessionalsSection,
  JoinCommunitySection,
  ProfessionalRequirements
} from "../../components/Landing";


gsap.registerPlugin(ScrollTrigger);

export const ProfessionalsLanding: React.FC = () => {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    return () => {
      ScrollTrigger.getAll().forEach(t => t.kill());
    };
  }, []);

  return (
    <div className="professionals-landing" ref={container}>
      <HeroSection />
      <EvolutionarySection />
      <ProposalSection />
      <DifferentialSection />
      <ValueSection />
      <PurposeProfessionalsSection />
      <ProfessionalRequirements />
      <JoinCommunitySection />
    </div>
  );
};
